import { render, staticRenderFns } from "./legend2.vue?vue&type=template&id=00b9cddd&scoped=true"
import script from "./legend2.vue?vue&type=script&lang=js"
export * from "./legend2.vue?vue&type=script&lang=js"
import style0 from "./legend2.vue?vue&type=style&index=0&id=00b9cddd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b9cddd",
  null
  
)

export default component.exports